import { Injectable, EventEmitter } from '@angular/core';

/**
 * 
 * */
@Injectable({ providedIn: 'root' })
export class PanelScrollingService {
  move: EventEmitter<string> = new EventEmitter<string>();

  toggleSales: EventEmitter<boolean> = new EventEmitter<boolean>();

  moveToPage(pageName: string): void {
    this.move.emit(pageName);
  }

  toggleSalesDetails(show: boolean): void {
    this.toggleSales.emit(show);
  }
}
